'use strict';
'use es6';
// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/blob/master/UIComponents/docs/open-source.md
// *****************************************************************************************

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: ', ';\n  align-self: ', ';\n  flex-direction: ', ';\n  justify-content: ', ';\n  flex-wrap: ', ';\n'], ['\n  display: flex;\n  align-items: ', ';\n  align-self: ', ';\n  flex-direction: ', ';\n  justify-content: ', ';\n  flex-wrap: ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _chunk = require('./chunk1');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ALIGN_OPTIONS = {
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};

var ALIGN_SELF_OPTIONS = {
  auto: '',
  baseline: 'baseline',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start',
  stretch: 'stretch'
};

var DIRECTION_OPTIONS = {
  column: 'column',
  row: '',
  'column-reverse': 'column-reverse',
  'row-reverse': 'row-reverse'
};

var JUSTIFY_OPTIONS = {
  around: 'space-around',
  between: 'space-between',
  center: 'center',
  end: 'flex-end',
  start: 'flex-start'
};

var WRAP_OPTIONS = {
  nowrap: '',
  wrap: 'wrap'
};

var StyledFlex = /*#__PURE__*/_styledComponents2.default.div.withConfig({
  displayName: 'Flex__StyledFlex'
}).withConfig({
  displayName: 'Flex__StyledFlex'
})(_templateObject, function (props) {
  return ALIGN_OPTIONS[props.align];
}, function (props) {
  return ALIGN_SELF_OPTIONS[props.alignSelf];
}, function (props) {
  return DIRECTION_OPTIONS[props.direction];
}, function (props) {
  return JUSTIFY_OPTIONS[props.justify];
}, function (props) {
  return WRAP_OPTIONS[props.wrap];
});

function Flex(props) {
  var children = props.children,
      rest = (0, _chunk.objectWithoutProperties)(props, ['children']);

  return _react2.default.createElement(StyledFlex, rest, children);
}

Flex.propTypes = {
  align: _react.PropTypes.oneOf(Object.keys(ALIGN_OPTIONS)),
  alignSelf: _react.PropTypes.oneOf(Object.keys(ALIGN_SELF_OPTIONS)),
  children: _react.PropTypes.node.isRequired,
  className: _react.PropTypes.string,
  direction: _react.PropTypes.oneOf(Object.keys(DIRECTION_OPTIONS)),
  justify: _react.PropTypes.oneOf(Object.keys(JUSTIFY_OPTIONS)),
  wrap: _react.PropTypes.oneOf(Object.keys(WRAP_OPTIONS))
};

Flex.defaultProps = {
  align: 'start',
  direction: 'row',
  justify: 'start',
  wrap: 'nowrap'
};

Flex.displayName = 'Flex';

exports.default = Flex;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/vendor/canvas/Flex.js
// module id = 283
// module chunks = 0